var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIpo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#E7EDFC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7847_26556",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7847_26556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0001 31.9961H28.0001C27.7167 31.9961 27.4792 31.9003 27.2876 31.7086C27.0959 31.5169 27.0001 31.2794 27.0001 30.9961C27.0001 30.7128 27.0959 30.4753 27.2876 30.2836C27.4792 30.0919 27.7167 29.9961 28.0001 29.9961H30.0001V27.9961C30.0001 27.7128 30.0959 27.4753 30.2876 27.2836C30.4792 27.0919 30.7167 26.9961 31.0001 26.9961C31.2834 26.9961 31.5209 27.0919 31.7126 27.2836C31.9042 27.4753 32.0001 27.7128 32.0001 27.9961V29.9961H34.0001C34.2834 29.9961 34.5209 30.0919 34.7126 30.2836C34.9042 30.4753 35.0001 30.7128 35.0001 30.9961C35.0001 31.2794 34.9042 31.5169 34.7126 31.7086C34.5209 31.9003 34.2834 31.9961 34.0001 31.9961H32.0001V33.9961C32.0001 34.2794 31.9042 34.5169 31.7126 34.7086C31.5209 34.9003 31.2834 34.9961 31.0001 34.9961C30.7167 34.9961 30.4792 34.9003 30.2876 34.7086C30.0959 34.5169 30.0001 34.2794 30.0001 33.9961V31.9961ZM15.0001 31.9961C14.7167 31.9961 14.4792 31.9003 14.2876 31.7086C14.0959 31.5169 14.0001 31.2794 14.0001 30.9961V25.9961H13.8251C13.5084 25.9961 13.2501 25.8753 13.0501 25.6336C12.8501 25.3919 12.7834 25.1128 12.8501 24.7961L13.8501 19.7961C13.9001 19.5628 14.0167 19.3711 14.2001 19.2211C14.3834 19.0711 14.5917 18.9961 14.8251 18.9961H28.1751C28.4084 18.9961 28.6167 19.0711 28.8001 19.2211C28.9834 19.3711 29.1001 19.5628 29.1501 19.7961L30.1501 24.7961C30.2167 25.1128 30.1501 25.3919 29.9501 25.6336C29.7501 25.8753 29.4917 25.9961 29.1751 25.9961H29.0001V27.9961C29.0001 28.2794 28.9042 28.5169 28.7126 28.7086C28.5209 28.9003 28.2834 28.9961 28.0001 28.9961C27.7167 28.9961 27.4792 28.9003 27.2876 28.7086C27.0959 28.5169 27.0001 28.2794 27.0001 27.9961V25.9961H23.0001V30.9961C23.0001 31.2794 22.9042 31.5169 22.7126 31.7086C22.5209 31.9003 22.2834 31.9961 22.0001 31.9961H15.0001ZM16.0001 29.9961H21.0001V25.9961H16.0001V29.9961ZM15.0001 17.9961C14.7167 17.9961 14.4792 17.9003 14.2876 17.7086C14.0959 17.5169 14.0001 17.2794 14.0001 16.9961C14.0001 16.7128 14.0959 16.4753 14.2876 16.2836C14.4792 16.0919 14.7167 15.9961 15.0001 15.9961H28.0001C28.2834 15.9961 28.5209 16.0919 28.7126 16.2836C28.9042 16.4753 29.0001 16.7128 29.0001 16.9961C29.0001 17.2794 28.9042 17.5169 28.7126 17.7086C28.5209 17.9003 28.2834 17.9961 28.0001 17.9961H15.0001Z",
    fill: "#41558D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIpo);
export default __webpack_public_path__ + "static/media/IPO.61558aef8f2326ec8414fa8e901d012e.svg";
export { ForwardRef as ReactComponent };